import React, { useState } from "react";
import {
  Box,
  Stack,
  Typography,
  Grid,
  TextField,
  Radio,
  RadioGroup,
  FormControlLabel,
  Button,
  useMediaQuery,
} from "@mui/material";
import Email from "@mui/icons-material/Email";
import Facebook from "@mui/icons-material/Facebook";
import Instagram from "@mui/icons-material/Instagram";
import LinkedIn from "@mui/icons-material/LinkedIn";
import LocationOn from "@mui/icons-material/LocationOn";
import Phone from "@mui/icons-material/Phone";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    subject: "",
    message: "",
  });

  const handleInputChange = (field) => (event) => {
    setFormData({
      ...formData,
      [field]: event.target.value,
    });
  };

  const handleSubjectChange = (event) => {
    setFormData({
      ...formData,
      subject: event.target.value,
    });
  };

  const isMobile = useMediaQuery("(max-width:1439px)"); // Mobile & Tablet view

  const subjectOptions = [
    "General Inquiry",
    "Careers",
    "Services",
    "Products",
  ];

  const contactInfo = {
    phone: "077 444 3272",
    email: "careers@rubaai.net",
    address: "No 08, Thiruvalluvar Supermarket, Bustand Building, Mannar.",
  };

  return (
    <Box
      sx={{
        background: "#000000",
        width: "100%",
        minHeight: "100vh",
        fontFamily: "Roboto",
        px: isMobile ? 2 : 0,
        py: isMobile ? 4 : 0,
      }}
    >
      {/* Title Section */}
      <Box sx={{ textAlign: "center", py: isMobile ? 3 : 5, px: 2 }}>
        <Typography
          sx={{
            fontWeight: "bold",
            fontSize: isMobile ? "28px" : "54px",
            lineHeight: isMobile ? "36px" : "64px",
            color: "white",
            mb: 2,
          }}
        >
          Contact Us
        </Typography>
        <Typography
          sx={{
            fontSize: isMobile ? "16px" : "24px",
            color: "white",
            maxWidth: isMobile ? "300px" : "1140px",
            mx: "auto",
          }}
        >
          Interested in working with us? Let us know your expectations and
          specific needs. Reach out today, and let&apos;s explore how we can
          collaborate effectively!
        </Typography>
      </Box>

      {/* Main White Container */}
      <Box
        sx={{
          backgroundColor: "white",
          borderRadius: isMobile ? "12px" : "18px",
          border: isMobile ? "4px solid white" : "10px solid white",
          maxWidth: isMobile ? "375px" : "1100px",
          mx: "auto",
          overflow: "hidden",
          boxShadow: isMobile
            ? "0px 0px 20px rgba(0,0,0,0.1)"
            : "0px 0px 30px rgba(0,0,0,0.15)",
          display: "flex",
          flexDirection: isMobile ? "column" : "row",
        }}
      >
        {/* Black Info Card */}
        <Box
          sx={{
            background: "black",
            color: "white",
            p: isMobile ? 3 : 5,
            width: isMobile ? "100%" : "40%",
            borderRadius: isMobile ? "12px 12px 12px 12px" : "10px 10px 10px 10px",
            mb: isMobile ? 3 : 0,
            alignItems:isMobile ?"center":"flex-start",
            textAlign:isMobile ?"center":"left",
          }}
        >
          <Typography sx={{ fontSize: isMobile ? "20px" : "28px", fontWeight: 600, mb: 2 }}>
            Contact Information
          </Typography>
          <Typography sx={{ fontSize: isMobile ? "14px" : "18px", color: "#c8c8c8", mb: 3 }}>
            Say something to start a live chat!
          </Typography>

          <Stack spacing={isMobile ? 7 : 6} sx={{ mb: isMobile ? 6 : 20 }}>
            <Stack direction={isMobile?"column" :"row"} spacing={1} alignItems={isMobile?"center" :"flex-start"}>
              <Phone sx={{ fontSize: isMobile ? 20 : 24 }} />
              <Typography sx={{ fontSize: isMobile ? "14px" : "16px" }}>
                {contactInfo.phone}
              </Typography>
            </Stack>
            <Stack direction={isMobile?"column" :"row"} spacing={1} alignItems="center">
              <Email sx={{ fontSize: isMobile ? 20 : 24 }} />
              <Typography sx={{ fontSize: isMobile ? "14px" : "16px" }}>
                {contactInfo.email}
              </Typography>
            </Stack>
            <Stack direction={isMobile?"column" :"row"} spacing={1} alignItems="center">
              <LocationOn sx={{ fontSize: isMobile ? 20 : 24, mt: 0.5 }} />
              <Typography
                sx={{
                  fontSize: isMobile ? "14px" : "16px",
                  maxWidth: isMobile ? "250px" : "260px",
                }}
              >
                {contactInfo.address}
              </Typography>
            </Stack>
          </Stack>

          {/* Social Icons */}
          <Stack
            direction="row"
            spacing={2}

            justifyContent={isMobile?"center":"flex-start"}
            sx={{
              mt: 2,
            }}
          >
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Facebook sx={{ fontSize: 16, color: "black" }} />
            </Box>
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <Instagram sx={{ fontSize: 16, color: "black" }} />
            </Box>
            <Box
              sx={{
                width: 30,
                height: 30,
                borderRadius: "50%",
                backgroundColor: "white",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <LinkedIn sx={{ fontSize: 16, color: "black" }} />
            </Box>
          </Stack>
        </Box>

        {/* Contact Form */}
        <Box
          sx={{
            width: isMobile ? "100%" : "60%",
            p: isMobile ? 3 : 5,
          }}
        >
          <Grid container spacing={isMobile ? 2 : 3}>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="First Name" variant="standard"  placeholder=" Fatima" value={formData.firstName} onChange={handleInputChange("firstName")}   InputProps={{
    sx: {
      "& input::placeholder": {
        color: "#CFCFCF",
        opacity: 1,
      },
    },
  }}/>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Last Name" variant="standard" placeholder="  Ashta" value={formData.lastName} onChange={handleInputChange("lastName")} InputProps={{
  sx: {
    "& input::placeholder": {
      color: "#CFCFCF",
      opacity: 1,
    },
  },
}}/>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Email" variant="standard"  placeholder=" example@email.com" value={formData.email} onChange={handleInputChange("email")} InputProps={{
  sx: {
    "& input::placeholder": {
      color: "#CFCFCF",
      opacity: 1,
    },
  },
}}/>
            </Grid>
            <Grid item xs={12} sm={6}>
              <TextField fullWidth label="Phone Number" variant="standard" placeholder=" +94 775665223" value={formData.phoneNumber} onChange={handleInputChange("phoneNumber")} InputProps={{
  sx: {
    "& input::placeholder": {
      color: "#CFCFCF",
      opacity: 1,
    },
  },
}}/>
            </Grid>
          </Grid>

          {/* Subject */}
          <Box sx={{ mt: 3 }}>
            <Typography sx={{ fontWeight: 600, fontSize: "14px", mb: 1 }}>
              Select Subject?
            </Typography>
            <RadioGroup value={formData.subject} onChange={handleSubjectChange} row={!isMobile}>
              {subjectOptions.map((option, index) => (
                <FormControlLabel
                  key={index}
                  value={option}
                  control={<Radio size="small" />}
                  label={option}
                  sx={{ mr: isMobile ? 0 : 2 }}
                />
              ))}
            </RadioGroup>
          </Box>

          {/* Message */}
          <TextField
            fullWidth
            label="Message"
            placeholder="Write your message.."
            variant="standard"
            multiline
            rows={isMobile ? 3 : 2}
            sx={{ mt: 3 }}
            value={formData.message}
            onChange={handleInputChange("message")}
          />

          {/* Send Button */}
          <Box sx={{ textAlign: "right", mt: 4 }}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "black",
                px: 5,
                py: 1.5,
                fontSize: "16px",
                borderRadius: "6px",
                "&:hover": { bgcolor: "#333" },
              }}
            >
              Send Message
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default ContactUs;
